import React from 'react'
import {
  IonSkeletonText
} from '@ionic/react'
import CircelCardSkelton from '../../../components/skeletons/CircelCardSkelton'
import './styles.scss'

const PodcastHeaderSkeleton = () => {
  return (
    <div className='podcast-header-skeleton'>
      <figure>
        <CircelCardSkelton />
      </figure>
      <IonSkeletonText className='button' animated />
      <div className='information'>
        <IonSkeletonText className='title' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText style={{ width: '70%', marginBottom: '10px' }} className='text' animated />
        <IonSkeletonText style={{ width: '90px' }} className='data' animated />
        <IonSkeletonText className='data' animated />
        <IonSkeletonText className='data' animated />
        <IonSkeletonText style={{ width: '80px' }} className='data' animated />
      </div>
    </div>
  )
}

export default PodcastHeaderSkeleton
